import script from "./AdminImagePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminImagePreview.vue?vue&type=script&setup=true&lang=ts"

import "./AdminImagePreview.vue?vue&type=style&index=0&id=93921d66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93921d66"]])

export default __exports__